module.exports = __webpack_public_path__ + "static/media/logout.4a6213d2.svg";